import { FC } from "react";

const CONTENT_LINE_WIDTHS = [
  "100%",
  "94%",
  "97%",
  "88%",
  "72%",
  "96%",
  "91%",
  "64%",
  "98%",
  "40%",
];

const TextLessonSkeleton: FC = () => {
  return (
    <div className="pt-0 mt-0">
      <div className="overflow-hidden bg-fds-canvas-primary w-full pb-fds-72 min-h-[100vh]">
        <div className="pt-0 mt-0 exercise-content-box">
          <div className="w-full flex flex-col lg:flex-row-reverse lg:justify-between lg:items-center lg:py-6">
            <div className="w-full lg:w-auto flex py-2.5 gap-4 justify-between lg:justify-start">
              <div className="h-10 w-20 bg-fds-tertiary-select animate-pulse rounded-4" />
              <div className="h-10 w-20 bg-fds-tertiary-select animate-pulse rounded-4" />
            </div>
            <div className="flex w-full justify-between gap-x-1 items-center">
              <div className="h-7 w-2/3 max-w-md bg-fds-tertiary-select animate-pulse rounded-4 m-4" />
            </div>
          </div>
          <div className="overflow-hidden">
            <div className="mt-0 lg:px-6 px-4 pt-4 lg:pt-6">
              <div className="mb-4 flex flex-col gap-3">
                {CONTENT_LINE_WIDTHS.map((width, idx) => (
                  <div
                    key={idx}
                    className={`h-4 bg-fds-tertiary-select animate-pulse rounded-4 w-[${width}]`}
                  />
                ))}
              </div>
              <div className="h-10 w-52 bg-fds-tertiary-select animate-pulse rounded-4 mb-6 mt-8" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextLessonSkeleton;
